@if (menuState().open) {
  <div class="app-context-menu" [ngStyle]="menuStyles()" (click)="$event.stopPropagation()" (contextmenu)="$event.preventDefault()">
    @if (menuState().title) {
      <div class="app-context-menu__title">{{ menuState().title }}</div>
    }

    <div class="app-context-menu__items">
      @for (item of menuState().items; track item.id) {
        <button
          type="button"
          class="app-context-menu__item"
          [class.is-danger]="item.tone === 'danger'"
          [disabled]="item.disabled"
          (click)="invoke(item.id)"
        >
          @if (item.icon) {
            <ion-icon [name]="item.icon"></ion-icon>
          }
          <span>{{ item.label }}</span>
        </button>
      }
    </div>
  </div>
}
